import $ from 'jquery';
import ko from '@tko/build.knockout';
import _ from 'lodash';
import moment from 'moment-timezone';
import FormatterCommon from './formatter-common';
import TemplateCommon from '../helpers/template-common';
import TranslationService from '../../services/translation.service';
import xml2json from '../xml2json';

var FILTER_LHS_REGEX = '([\\w\\.]+)'; // e.g. dimcallstatus.callstatus
var FILTER_RHS_REGEX = '(\\w+[\\w\\s]*)'; // e.g. Not Connected
var FILTER_OPERATOR_REGEX = '(=|>|<|<=|>=)';

var INNER_ROWS_PAGE_SIZE = 10;

var DRILLQUERY_DATASET_URL_MAP = {
    callxml: '#historical2/endpoints/tabid/3/params/',
    participantxml: '#historical2/meetings/tabid/2/params/',
    meetingxml: '#historical2/meetings/tabid/0/params/'
};

const COLUMN_TITLE_MAP = {
  ['dimipsubnet.dimipsubnetsid']: 'Network Id',
  ['dimendpoint.dimendpointsid']: 'Endpoint Id',
  ['dimcallstatus.callstatus']: 'Call Status',
  ['fctcall.packetlossrate']: 'Packet Loss Percentage',
};

function FindColumnOption(name, columnOptions) {
    var result = null;
    for (var i = 0; i < columnOptions.length; i++) {
        if (columnOptions[i].name === name) {
            result = columnOptions[i];
            break;
        }
    }
    return result;
}

function isNotEmptyString(str) {
    return _.isString(str) && !_.isEmpty(str);
}

function formatByType(rawValue, type, useAbbreviation, gridFormatterCommon) {
    var formattedValue;

    switch (type) {
        case 'currency':
            formattedValue = '$' + rawValue;
            break;
        case 'datetime':
            formattedValue = gridFormatterCommon.getTimeString(rawValue);
            break;
        case 'integer':
        case 'numeric':
            formattedValue = FormatterCommon.getFormattedNumber(rawValue, useAbbreviation);
            break;
        case 'percentage':
            formattedValue = parseFloat(parseFloat(rawValue).toFixed(2)) + '%';
            break;
        default:
            formattedValue = rawValue;
    }

    return FormatterCommon.sanitize(formattedValue);
}

function GetFormattedValue(options, userObj) {
    var row = options.row;
    var rawValue = options.rawValue;
    var name = options.name;
    var columnOptions = options.columnOptions;
    var gridFormatterCommon = options.gridFormatterCommon;
    var epappsid = options.epappsid;
    var startDate = options.startDate;
    var endDate = options.endDate;
    var useAbbreviation = _.get(options, 'useAbbreviation', false);

    var colOption = FindColumnOption(name, columnOptions);
    var result = rawValue ? formatByType(rawValue, _.get(colOption, 'type'), useAbbreviation, gridFormatterCommon) : null;
    var channel;
    var href;

    if (epappsid && (epappsid > 0) && (name === 'dimendpoint.endpointname')) {
        result = TemplateCommon.getHtmlTagWithContentAndAttrs('a', result, {
            href: '#historical2/endpoints/' + epappsid + '/tabid/0'
        });
    }

    if (name === 'dimendpoint.endpointname') {
        result = TemplateCommon.getSpanWithContentAndAttrs(result, { title: rawValue });
    }
    else if (name === 'dimqualityclass.qualityclass') {
        result = gridFormatterCommon.getQualityClass(result);
    }
    else if (name === 'dimendpoint.vulnerability') {
        result = gridFormatterCommon.setClass(result, 'textRedNormal');
    }
    else if (name === 'dimcallstatus.callstatus') {
        result = gridFormatterCommon.formatStatusDiv(result);
    } else if (name === 'dimuser.email') {
      if (userObj && !userObj.featureFlags.UserProfileLinkOptOut) {
        let userId = row['dimuser.dimusersid'],
            dateFormat = 'YYYY/MM/DD', // TODO: Strong assumption about date format. Any way around it?
            startDateMillis = moment(startDate, dateFormat).valueOf(),
            endDateMillis = moment(endDate, dateFormat).valueOf();
        if (userId) {
          let href = '#historical2/userdetails/' + userId;
          if (startDateMillis && endDateMillis) {
            href += '/' + startDateMillis + '/' + endDateMillis
          }
          result = TemplateCommon.getHtmlTagWithContentAndAttrs('a', result, {
            href: href,
          });

          result = gridFormatterCommon.setClass(result, 'dataset-link');
        }
      }
    }

    if (name.search('.jitter') > -1) {
      channel = getChannelFromStreamType(getStreamTypeFromRow(row));
      result = gridFormatterCommon.formatJitterValue(result, colOption.type, channel);
    }
    else if (name.search('.packetlossrate') > -1 || name.search('.packetlossdiag') > -1) {
      channel = getChannelFromStreamType(getStreamTypeFromRow(row));
      result = gridFormatterCommon.formatPacketLossValue(result, colOption.type, channel);
    } else if (name.search(/\.latency$/) > -1 || name.search(/\.avglatency$/) > -1 || name.search('.latencydiag') > -1) { // only match "average latency" columns, not "max latency"
      channel = getChannelFromStreamType(getStreamTypeFromRow(row));
      result = gridFormatterCommon.formatLatencyValue(result, colOption.type, channel);
    };
    // todo align numerics to the right

    if (colOption && colOption.name === 'manageendpointsubcategoryxml.title') {
        result = TemplateCommon.getSpanWithContentAndAttrs(result, {
            title: result,
            style: 'font-weight:bold'
        });
    }

    if (colOption && colOption.name === 'dimsystemtype.systemtypedesc') {
        result = TemplateCommon.getSpanWithContentAndAttrs(result, { title: result, style: 'font-weight:bold' });
    }

    if (colOption && colOption.name.indexOf('_changerate') !== -1) {
        if (rawValue > 0) {
            result =
                TemplateCommon.getHtmlTagWithContentAndAttrs('i', '', {
                    'class': 'flaticon-sort33',
                    style: 'color:var(--good-color)!important',
                    title: 'Change Rate'
                }) +
                '&nbsp;' +
                TemplateCommon.getSpanWithContentAndAttrs(result, { title: result });

        } else if (rawValue < 0) {
            result =
                TemplateCommon.getHtmlTagWithContentAndAttrs('i', '', {
                    'class': 'flaticon-sort37',
                    style: 'color:var(--bad-color)!important',
                    title: 'Change Rate'
                }) +
                '&nbsp;' +
                TemplateCommon.getSpanWithContentAndAttrs(result, { title: result });

        } else {
            result =
                TemplateCommon.getDivWithContentAndAttrs('--', {
                    style: 'color:var(--unknown-color)!important;display:inline-block;font-weight:bold;font-size:18px;line-height:17px',
                    title: 'Change Rate'
                }) + '&nbsp;' +
                TemplateCommon.getDivWithContentAndAttrs(result, {
                    style: 'display:inline-block',
                    title: result
                });
        }
    }
    if (!_.isEmpty(_.get(colOption, 'drillAcrossQuery'))) {
        href = getBaseDrillAcrossQueryURL(colOption.drillAcrossQuery);
        href += getDateURLParms(startDate, endDate);
        href += encodeURIComponent(getDrillAcrossQueryURL(row, colOption.drillAcrossQuery, colOption));
        result = TemplateCommon.getHtmlTagWithContentAndAttrs('a', result, { href: href });
    }

    return result;
}

function getStreamTypeFromRow(row) {
  if (row && typeof row === 'object') {
    for (let [key, value] of Object.entries(row)) {
      if (key.search('.streamtype') > -1) {
        return value;
      }
    }
  }
  return undefined;
}

function getChannelFromStreamType(streamType) {
  let possibleChannels = ["audio", "video", "presentation"];
  let channel;
  // we assume streamType is a string formatted as such: "[Channel] - (RX/TX)" e.g. "Audio - RX"
  if (streamType && typeof streamType === 'string') {
    channel = streamType.toLowerCase().substr(0, streamType.indexOf(" "));
    if (!channel || !possibleChannels.includes(channel)) {
      channel = undefined;
    }
  }
  return channel;
}

function isNoOperatorFilter(filter) {
    return (new RegExp('^' + FILTER_LHS_REGEX + '$')).test(filter);
}

function isOperatorFilter(filter) {
    return (new RegExp('^' + FILTER_LHS_REGEX + '\\s?' + FILTER_OPERATOR_REGEX + '\\s?' + FILTER_RHS_REGEX + '$')).test(filter);
}

function getBaseDrillAcrossQueryURL(drillAcrossQuery) {
    return DRILLQUERY_DATASET_URL_MAP[drillAcrossQuery.datasetname] || '';
}

function getDateURLParms(startDate, endDate) {
    if (isNotEmptyString(startDate) && isNotEmptyString(endDate)) {
       return "inpstartdate|" + startDate + "&inpenddate|" + endDate + "/&";
    }
    return '';
}

function getDrillAcrossQueryURL(row, drillAcrossQuery, colOption) {
    var url = 'wherecondition|';
    var params = [];
    var filterList = _.isArray(drillAcrossQuery.filter) ? drillAcrossQuery.filter : [drillAcrossQuery.filter];
    let convertedFilters = []
    _.forEach(filterList, function(field) {
        if (isNoOperatorFilter(field)) {
            let filter = {
              selectedLhs: field, 
              selectedLhsTitle: COLUMN_TITLE_MAP[field],
              selectedOperator: '=',
              rhsText: row[field],
              valueType: 'string',
              selectedConjunction: 'AND'
            };
            convertedFilters.push(filter);
        }
        else if (isOperatorFilter(field)) {
            let filter = {
              selectedConjunction: 'AND'
            };
            if (field.indexOf(' = ') > 0) {
                let filterParts = field.split(' = ');
                filter.selectedLhs = filterParts[0];
                filter.selectedLhsTitle = COLUMN_TITLE_MAP[filterParts[0]];
                filter.rhsText = filterParts[1];
                filter.selectedOperator = '=';
                filter.valueType = 'string';
                convertedFilters.push(filter);
            } else if (field.indexOf(' > ') > 0) {
                let filterParts = field.split(' > ');
                filter.selectedLhs = filterParts[0];
                filter.selectedLhsTitle = COLUMN_TITLE_MAP[filterParts[0]];
                filter.rhsText = filterParts[1];
                filter.selectedOperator = '>';
                filter.valueType = 'numeric';
                convertedFilters.push(filter);
            } else if (field.indexOf(' < ') > 0) {
                let filterParts = field.split(' < ');
                filter.selectedLhs = filterParts[0];
                filter.selectedLhsTitle = COLUMN_TITLE_MAP[filterParts[0]];
                filter.rhsText = filterParts[1];
                filter.selectedOperator = '<';
                filter.valueType = 'numeric';
                convertedFilters.push(filter);
            }
        }
    });
    params.push(JSON.stringify(convertedFilters));
    return url + params.join('-and-');
}

function GetHeaders(display, columnOptions) {
    var headers = [];
    if (display && display.length > 0) {
        for (var i = 0; i < display.length; i++) {
            var name = display[i];
            var colOption = FindColumnOption(name, columnOptions);

            if (colOption && colOption.title) {
                headers.push(colOption.title);
            } else {
                headers.push(name);
            }
        }
    }

    return headers;
}

function SetWhereConditionForInnerGrid(paramsObj, parentCols, parentData) {
    if (parentCols && (parentCols.length > 0)) {
        var groups = [
            { conditions: [] }
        ];
        var conditions = groups[groups.length - 1].conditions;

        for (var j = 0; j < parentCols.length; j++) {
            conditions.push({
                selectedLhs: parentCols[j].name,
                selectedOperator: '=',
                rhsText: parentData['_' + parentCols[j].name.replace('.', '_')],
                valueType: parentData['_' + parentCols[j].name.replace('.', '_') + '.type'],
                selectedConjunction: 'AND'
            });
        }

        paramsObj.WhereCondition = ko.toJSON(groups);
    }
}

function GetMetadata(xml) {
    var result = {};
    var detail = [];
    var summary = [];
    var summarycolopts = [];
    var detailcolopts = [];
    var detailIdCols = [];
    var detailIdColsObj = [];

    if (!xml) {
        return result;
    }

    var retJson = xml2json(xml);

    if (_.get(retJson, 'detail.row')) {
        detail = retJson.detail.row;
        detailcolopts = _.map(detail, function(detailitem, index) {
            let newVar = {
                name: detailitem.columnKey,
                title: detailitem.columnDescription,
                tooltip: !_.isEmpty(detailitem.columnLongDescription) ? detailitem.columnLongDescription : detailitem.columnDescription,
                type: detailitem.datatype,
                idCol: detailitem.coltype === 'id',
                seq: detailitem.columnSeq ? parseInt(detailitem.columnSeq) : index,
                childDataset: _.get(detailitem, 'childQuery.childquery.datasetname', null),
                childFkCol: _.get(detailitem, 'childQuery.childquery.filter', null),
                drillAcrossQuery: _.get(detailitem, 'drillAcrossQuery.drillacrossquery', null),
                isDefaultColumn: detailitem.defaultFlag !== '0' //treat all columns as default unless explicitly set to '0'
            };
            // if you need to inject something for testing, this is where to do it
            return newVar;
        });
    }

    if (_.get(retJson, 'summary.row')) {
        summary = retJson.summary.row;
        if (!_.isArray(summary)) {
            summary = [summary];
        }
        summarycolopts = _.map(summary, function(item, index) {
            return {
                name: item.columnKey,
                title: item.columnDescription,
                tooltip: !_.isEmpty(item.columnLongDescription) ? item.columnLongDescription : item.columnDescription,
                type: item.datatype,
                seq: item.columnSeq ? parseInt(item.columnSeq) : index,
                isDefaultColumn: item.defaultFlag !== '0' //treat all columns as default unless explicitly set to '0'
            };
        });
    }

    detailIdCols = _.chain(detailcolopts).filter('idCol').map('name').value();
    detailIdColsObj = _.chain(detailcolopts).filter('idCol').map(function(item){
        return { name: item.name, type: item.type };
    }).value();

    var specialDetailCols = $.grep(detailcolopts,
        function (mdd) {
            return (mdd.name.indexOf('_') === 0);
        });

    var detailColsWithChild = $.grep(detailcolopts,
        function (mdd) {
            return mdd.childDataset;
        });

    var nonIdDetails = $.grep(detailcolopts,
        function (mdd) {
            return (mdd.name.indexOf('_') !== 0) && !mdd.idCol;
        });

    nonIdDetails.sort(function (a, b) {
        return a.seq < b.seq ? -1 : a.seq > b.seq ? 1 : 0;
    });

    var nonIdDetailsColNames = $.map(nonIdDetails, function (nitem) {
        return nitem.name;
    });

    var nonIdDefaultDetailColNames = $.map(nonIdDetails, function (nitem) {
        return nitem.isDefaultColumn ? nitem.name : null;
    });

    var nonIdDetailsColTitles = $.map(nonIdDetails, function (nitem) {
        return nitem.title;
    });

    var nonIdSummary = $.grep(summarycolopts,
        function (mdd) {
            return (mdd.name.indexOf('_') !== 0) && !mdd.idCol;
        });

    nonIdSummary.sort(function (a, b) {
        return a.seq < b.seq ? -1 : a.seq > b.seq ? 1 : 0;
    });

    result = {
        summary: summarycolopts,
        detail: detailcolopts,
        detailIdCols: detailIdCols,
        detailIdColsObj: detailIdColsObj,
        nonIdDetails: nonIdDetails,
        nonIdSummary: nonIdSummary,
        nonIdDetailsColNames: nonIdDetailsColNames,
        nonIdDefaultDetailColNames: nonIdDefaultDetailColNames,
        nonIdDetailsColTitles: nonIdDetailsColTitles,
        specialDetailCols: specialDetailCols,
        detailColsWithChild: detailColsWithChild
    };

    return result;
}

function composeChildTable(parentTableRows, options, metadata, dataProvider, dataSources, innerwidths, gridFormatterCommon, userObj) {
    var innerGridQueryid = 'FlexAccessQueryWithMetadata';
    let translationService = new TranslationService();
    var parentfkcolumns = [{
        name: metadata.detailColsWithChild[0].childFkCol,
    }];

    _.forEach(parentTableRows, function(parentRow) {
        parentRow.innerTable = {
            headers: ko.observableArray(),
            rows: ko.observableArray(),
            currentPage: ko.observable(1),
            totalPages: ko.observable(1),
            sortAsc: ko.observable(true),
            sortIndex: ko.observable(),
            displayCols: ko.observable(),
            sortColumn: ko.observable()
        };

        parentRow._showInnerPager = ko.observable(false);

        parentRow._loadInnerRows = function(pageNum, sortColumn) {
            var self = this;

            var paramsJson = _.get(ko.unwrap(_.get(dataSources[0], 'observableParams')), 'paramsJson');
            var queryParams = JSON.parse(paramsJson);

            if (pageNum) {
                parentRow.innerTable.currentPage(pageNum);
            }

            SetWhereConditionForInnerGrid(queryParams, parentfkcolumns, this);
            queryParams.sortColumn = sortColumn || ko.unwrap(_.get(parentRow, 'innerTable.sortColumn'));
            queryParams.pageSize = INNER_ROWS_PAGE_SIZE;
            queryParams.pageNum = ko.unwrap(_.get(parentRow, 'innerTable.currentPage'));
            queryParams.dataset = _.get(metadata, 'detailColsWithChild[0].childDataset');
            queryParams.aggregatefact = '';
            queryParams.groupby = '';
            queryParams.timegrain = '';
            queryParams.tag = '';


            paramsJson = ko.toJSON(queryParams);

            return dataProvider.getQueryResultDatasetJson(innerGridQueryid, paramsJson)
                .then(function(retObj) {
                    var childMetadata = null;
                    var childDisplayColumns = null;
                    var childHeaders = [];
                    var childTableRowsWidth = [];

                    if (retObj && !_.isEmpty(retObj.Table)) {
                        childMetadata = GetMetadata(retObj.Table[0].Column1);
                        childDisplayColumns = childMetadata.nonIdDetailsColNames;
                        childHeaders = childMetadata.nonIdDetailsColTitles;

                        childTableRowsWidth = $.map(childDisplayColumns, function() {
                            return (100 / childDisplayColumns.length) + '%';
                        });
                    }

                    if (!_.isEmpty(_.get(retObj, 'Table1'))) {
                        var childTable = composeDetailList(
                            _.get(retObj, 'Table1[0].Column1'),
                            childDisplayColumns,
                            childMetadata,
                            gridFormatterCommon,
                            queryParams.inpStartDate,
                            queryParams.inpEndDate,
                            userObj
                        );

                        childTableRowsWidth.unshift('0%');
                        childHeaders.unshift('id');
                        childDisplayColumns.unshift('id');

                        innerwidths(childTableRowsWidth);
                        parentRow.innerTable.headers(childHeaders);

                        var maxCount = childTable.length;

                        if (!_.isEmpty(_.get(childTable, '[0]._recordCount'))) {
                            maxCount = childTable[0]._recordCount;
                        }

                        parentRow.innerTable.totalPages(Math.ceil(maxCount / queryParams.pageSize));
                        self._showInnerPager(self.innerTable.totalPages() > 1);

                        parentRow.innerTable.totalPages(Math.ceil(maxCount / queryParams.pageSize));
                        self._showInnerPager(self.innerTable.totalPages() > 1);  // todo this is no longer used

                        self.innerTable.rows((childTable.length ? childTable : []));
                        self.innerTable.displayCols(childDisplayColumns);
                    } else {
                        self.innerTable.totalPages(0);
                        self.innerTable.rows([]);
                        self._showInnerPager(false); // todo this is no longer used
                    }

                    return Promise.resolve();
                });
        };

        parentRow._actionCallback = function(index) {
            if (!options || !options.display) {
                return;
            }

            var colOpt = FindColumnOption(options.display[index - 1], options.columnOptions);

            if (colOpt && colOpt.clickActionCallback) {
                var paramsJson = _.get(ko.unwrap(_.get(dataSources[0], 'observableParams')), 'paramsJson');
                var paramsObj = JSON.parse(paramsJson);

                colOpt.clickActionCallback(this, paramsObj);
            }
        };
    });

    return parentTableRows;
}

function composeError(errMsg) {
    return {
        maxCount: 0,
        rows: [{
            col1: '',
            col2: errMsg,
            col3: ''
        }]
    };
}

function composeEmptyTable() {
    let translationService = new TranslationService();
    return {
        maxCount: 0,
        rows: [],
        cells: [{
            value: '',
            abbreviatedValue: '',
            footer: translationService.translate('noDataAvailable'),
            tooltip: translationService.translate('noDataAvailable'),
            cellclass: 'description-block border-right',
            cellwidthclass: 'inline-block multicellcell',
            change: null,
            changeiconclass: null,
            cellwidthpct: ['25%']
        }]
    };
}

function composeDetailList(xml, displayDetail, metadata, gridFormatterCommon, startDate, endDate, userObj) {
    var list = [];
    var retJson = xml2json(xml);
    var idCol = 'id';

    if (_.get(retJson, 'detail.row')) {
        list = retJson.detail.row;
    }

    if (!_.isArray(list)) {
        list = [list];
    }

    if (_.isEmpty(metadata.detailIdCols)) {
        idCol = _.first(metadata.detailIdCols);
    }

    var result = [];

    list.forEach(function (item) {
        var tempobj = {};

        if (item[idCol]) {
            tempobj.id = item[idCol];
        }
        else if (item.id) {
            tempobj.id = item.id;
        }
        else if (item._rowID) {
            tempobj.id = item._rowID;
        }

        _.forEach(displayDetail, function(detailCol) {
            tempobj[detailCol] = GetFormattedValue({
                row: item,
                rawValue: item[detailCol],
                name: detailCol,
                columnOptions: metadata.detail,
                id: tempobj.id,
                gridFormatterCommon: gridFormatterCommon,
                epappsid: item['dimendpoint.appsepid'],
                startDate: startDate,
                endDate: endDate
            }, userObj);
        });

        metadata.detailIdColsObj.forEach(function (ic) {
            tempobj['_' + ic.name] = item[ic.name];
            tempobj['_' + ic.name + '.type'] = ic.type;
        });

        metadata.specialDetailCols.forEach(function (sdc) {
            tempobj[sdc] = item[sdc];
        });

        if (item._recordCount) {
            tempobj._recordCount = item._recordCount;
        }
        if (item._pageID) {
            tempobj._pageID = item._pageID;
        }
        if (item._pageCount) {
            tempobj._pageCount = item._pageCount;
        }
        if (item._rowID) {
            tempobj._rowID = item._rowID;
        }
        result.push(tempobj);
    });
    return result;
}

export default {
    composeChildTable: composeChildTable,
    composeDetailList: composeDetailList,
    composeEmptyTable: composeEmptyTable,
    composeError: composeError,
    FindColumnOption: FindColumnOption,
    GetFormattedValue: GetFormattedValue,
    GetHeaders: GetHeaders,
    GetMetadata: GetMetadata,
    SetWhereConditionForInnerGrid: SetWhereConditionForInnerGrid
};
